import React, { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Button, RadioWithTitle } from '@/components/ui';
import {
  AddressIcon,
  BranchIcon,
  CheckMark,
  ChevronRightArrow,
  SelectBranch,
} from '@/components/SvgComponents';
import { DeliveryType } from '@/enums/numberSale';

import styles from './DeliveryAddressBranch.module.scss';

const DeliveryAddressBranch = ({
  formik,
  handleDeliveryTypeChange,
  onButtonClick,
  data,
  defaultBranchId,
}) => {
  const { t } = useTranslation();
  const [translatedBranchName, setTranslatedBranchName] = useState(
    formik.values.pickup_point_name,
  );

  useEffect(() => {
    if (formik.values.pickup_point_id || defaultBranchId) {
      const selectedBranch = data?.find(
        (branch) =>
          branch?.id ===
          Number(formik.values.pickup_point_id || defaultBranchId),
      );
      if (selectedBranch) {
        setTranslatedBranchName(selectedBranch?.name);
      }
    }
  }, [data, formik.values.pickup_point_id, defaultBranchId]);

  const DeliveryInfo = ({ deliveryType, formik }) => {
    if (deliveryType === 'self-pickup') {
      return formik.values.pickup_point_id ? (
        <div
          className={styles.delivery_btn}
          itemScope
          itemType='http://schema.org/Information'
        >
          <div>
            <CheckMark className={styles.checkIcon} />
            <span>{translatedBranchName}</span>
          </div>
          <div>
            <ChevronRightArrow />
          </div>
        </div>
      ) : (
        <>
          <SelectBranch />
          <span>{t('device:delivery.branchBtn')}</span>
        </>
      );
    }
    return formik.values.address_coordinates?.address ? (
      <div
        className={styles.delivery_btn}
        itemScope
        itemType='http://schema.org/Thing'
      >
        <div>
          <CheckMark className={styles.checkIcon} />
          <span>{formik.values.address_coordinates?.address}</span>
        </div>
        <div>
          <ChevronRightArrow />
        </div>
      </div>
    ) : (
      <>
        <SelectBranch />
        <span>{t('device:delivery.addressBtn')}</span>
      </>
    );
  };

  return (
    <div
      className={styles.wrapper}
      itemScope
      itemType='https://schema.org/DeliveryMode'
    >
      <div className={styles.radio_container}>
        <RadioWithTitle
          onChange={() => handleDeliveryTypeChange(DeliveryType.SELF_PICKUP)}
          checked={formik.values.delivery_type === DeliveryType.SELF_PICKUP}
          name='type'
          className={styles.radio_address}
          size='medium'
        >
          <div className={styles.inner_container}>
            <BranchIcon
              fill={
                formik.values.delivery_type === DeliveryType.SELF_PICKUP
                  ? 'var(--colorIconPrimary)'
                  : 'var( --colorIconSecondary)'
              }
            />
            <span className={styles.btnText}>
              {t('device:delivery.branch')}
            </span>
          </div>
        </RadioWithTitle>
        <RadioWithTitle
          onChange={() =>
            handleDeliveryTypeChange(DeliveryType.DELIVERY_TO_ADDRESS)
          }
          checked={
            formik.values.delivery_type === DeliveryType.DELIVERY_TO_ADDRESS
          }
          name='type'
          className={styles.radio_address}
          size='medium'
        >
          <div className={styles.inner_container}>
            <AddressIcon
              fill={
                formik.values.delivery_type === DeliveryType.DELIVERY_TO_ADDRESS
                  ? 'var(--colorIconPrimary)'
                  : 'var( --colorIconSecondary)'
              }
            />
            <span className={styles.btnText}>
              {t('device:delivery.address')}
            </span>
          </div>
        </RadioWithTitle>
      </div>
      <Button
        className={styles.btn_select}
        type='button'
        onClick={onButtonClick}
      >
        <DeliveryInfo
          deliveryType={formik.values.delivery_type}
          formik={formik}
        />
      </Button>
    </div>
  );
};
export default DeliveryAddressBranch;
